<template>
  <b-row no-gutters>
    <b-col cols="auto">
      <b-form-group
        label="Ülke Kodu"
        label-for="fax_region_code"
      >
        <div class="d-flex">
          <vue-country-code
            :preferred-countries="['tr', 'de', 'az']"
            class="form-control"
            :default-country="dataItem.fax_region_iso2"
            @onSelect="onSelect"
          />
          <b-form-input
            id="fax_region_code"
            v-model="dataItem.fax_region_code"
            type="number"
            class="bg-light phone_region_code"
            readonly
          />
        </div>
      </b-form-group>
    </b-col>
    <b-col>
      <b-form-group
        label="Fax"
        label-for="fax"
      >
        <cleave
          id="fax"
          v-model="dataItem.fax"
          class="form-control phone_number"
          :raw="true"
          :options="options.phone"
          placeholder="Fax"
        />
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
import {
  BFormGroup, BFormInput, BRow, BCol,
} from 'bootstrap-vue'
import Cleave from 'vue-cleave-component'
// eslint-disable-next-line import/no-extraneous-dependencies
import 'cleave.js/dist/addons/cleave-phone.tr'
import VueCountryCode from 'vue-country-code'

export default {
  name: 'FaxNumber',
  components: {
    BFormGroup,
    BFormInput,
    Cleave,
    BRow,
    BCol,
    VueCountryCode,
  },
  data() {
    return {
      options: {
        phone: {
          phone: true,
          phoneRegionCode: 'TR',
        },
      },
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['customers/dataItem']
    },
  },
  methods: {
    onSelect({ iso2, dialCode }) {
      this.dataItem.fax_region_code = dialCode
      this.dataItem.fax_region_iso2 = iso2
    },
  },
}
</script>
